import { DestinationAccountControllerType } from "../useDestinationAccount";

import ScrollableContainer from "../../../layout/scrollable-container";
import Container from "../../../layout/container";

import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";

import { TileContainer } from "./styles";
import { TitleLarge } from "../../../components/font";
import { OptionTile } from "@manifesthhqinc/ui-library";
import { STEP_DESTINATION_OPTIONS_TYPE } from "../../../class/transferDetails";
import HeadingContainer from "../../../layout/heading-container";

const DestinationOptions = (props: DestinationAccountControllerType) => {
  const { goToDestinationScreen, onClickExploreMyOptions } = props;

  return (
    <TransitionWrapper>
      <ScrollableContainer name="destination-selection">
        <Container>
          <HeadingContainer withProgressBar paneVariant="optionForm">
            <TitleLarge>Do you know where you want to transfer into?</TitleLarge>
          </HeadingContainer>
          <TileContainer $flexDirection="column" $width="100%">
            <OptionTile
              variant="clickthrough"
              appearance="secondary"
              supportingText="Provide details for the account you want to transfer into."
              onClick={() => goToDestinationScreen(STEP_DESTINATION_OPTIONS_TYPE)}
              name="knowMyDestination"
            >
              I know my destination account
            </OptionTile>
            <OptionTile
              variant="clickthrough"
              appearance="secondary"
              supportingText="We’ll help you figure out the best destination option for you."
              onClick={onClickExploreMyOptions}
              name="exploreMyOptions"
            >
              Explore my options
            </OptionTile>
          </TileContainer>
        </Container>
      </ScrollableContainer>
    </TransitionWrapper>
  );
};

export default DestinationOptions;
